/**
 * Selectors for images service state
 * @module services/images/redux/selectors
 */

/**
 * Latest bulk upload support incident report (or null)
 * @param {Object} state
 * @returns {Object|null}
 */
export function selectBulkUploadSupportError (state) {
  return state.bulkUploadSupportError || null
}
